import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './utils/element'
import * as api from './utils/api'
import utils from './utils/utils'
import store from './store/index'
import Print from 'vue-print-nb'
Vue.use(Print);

const arr = {
  api: api.default,
  utils
}
for (const key in arr) {
  Object.defineProperty(Vue.prototype, `$${key}`, {
    get: () => arr[key]
  })
}

require('./assets/css/tools.css')
require('./assets/css/common.css')

Vue.config.productionTip = false

router.afterEach(() => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
